import { useCallback } from 'react';

import { useClient } from 'urql';

import {
  PaymentStateExistenceDocument,
  type PaymentStateExistenceQuery,
} from '../../graphql/PaymentStateExistence.generated';

/**
 * Checks if a payment state exists for the given order.
 */
export const usePaymentStateExistence = () => {
  const client = useClient();

  return useCallback(
    async (orderId: string, orderType: string) => {
      const query = client.query<PaymentStateExistenceQuery>;

      const response = await query(
        PaymentStateExistenceDocument,
        { orderId, orderType },
        { requestPolicy: 'network-only' },
      ).toPromise();

      const paymentState = response.data?.orderPaymentState;

      return paymentState?.paymentIntentId;
    },
    [client.query],
  );
};
